<template lang="pug">
    v-autocomplete(dense 
        v-model="dataMerchantGroup"
        :disabled="disabled"
        :readonly="readonly"
        :label="label"
        :rules="rules"
        :items="listData"
        :item-text="text"
        item-value="merchantId" 
        @change="onSelect"
        :required = "required")
</template>
<script>
export default {
    name: "FSelectMerchantGroup",
    props: [
        "value",
        "disabled",
        "readonly",
        "label",
        "rules",
        "required",
        "corporateId",
        "corporateGroupId",
        "merchantType"
    ],
    data() {
        return {
            dataMerchantGroup: {},
            listData: []
        }
    },
    mounted() {
        this.doInit(this.value);
    },
    watch: {
        value(val){
            this.doInit(val);
        },
        corporateId(val){
            this.getMerchant();
        },
        corporateGroupId(val){
            this.getMerchant();
        },
        listData(val){
            this.dataMerchantGroup = val ? val.length > 0 ? val[0].merchantId : null : null;
            this.onSelect();
        }
    },
    methods: {
        text: (item) => item.merchantId + " - " + item.merchantName,
        doInit(values){
            this.dataMerchantGroup = values ? values : null;
        },
        getMerchant(){
            if (this.corporateId) {
                if (this.corporateGroupId) {
                    this.$http.get("/api/corporate/group/merchant/" + this.corporateId + "/" + this.corporateGroupId)
                        .then(success => {
                            if(this.merchantType) {
                                if(this.merchantType == "default"){
                                    this.listData = success.data.filter(merchant =>
                                        merchant.merchantType == "DBCR" || merchant.merchantType == "CR_ONLY");
                                } else {
                                    this.listData = success.data.filter(merchant =>
                                        merchant.merchantType == this.merchantType);
                                }
                            } else {
                                this.listData = success.data;
                            }
                        }, err => {
                            this.$message.error(err.response.data.message);
                        }).finally(() => (this.loading = false));
                }
            }
        },
        onSelect() {
            this.$emit("input", this.dataMerchantGroup);
            this.$emit("select", this.dataMerchantGroup);
            this.$emit("merchantGroup", this.valueData());
        },
        valueData(){
            let result = null;
            this.listData.map(element => {
                if (this.dataMerchantGroup === element.merchantId) {
                    result = element;
                }
            });
            return result;
        },
    },
}
</script>